import { requiredStrategy } from '../core';
import { emailFormatStrategy } from './email-format-strategy';

export const emailStrategy = (value: string) => {
  return requiredStrategy(value) && emailFormatStrategy(value);
};
